var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _vm.lead.logs.length
                        ? [
                            _c(
                              "v-timeline",
                              {
                                staticClass: "calendar-comments",
                                attrs: { dense: "", clipped: "" }
                              },
                              _vm._l(_vm.lead.logs, function(log, index) {
                                return _c(
                                  "v-timeline-item",
                                  {
                                    key: index,
                                    staticClass: "mb-4",
                                    attrs: { color: "secondary", small: "" }
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { justify: "space-between" } },
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            log.status_from_name
                                              ? [
                                                  _vm._v(
                                                    _vm._s(
                                                      log.status_from_name
                                                    ) + " -"
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(log.status_to_name) +
                                                " "
                                            ),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("h5", [
                                              _vm._v(
                                                _vm._s(log.user_name) +
                                                  " - " +
                                                  _vm._s(
                                                    log.dateCreated.slice(0, -3)
                                                  )
                                              )
                                            ])
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ]
                        : [
                            _c("h3", { staticClass: "text-center mt-3" }, [
                              _vm._v(
                                "\n                        No available logs\n                    "
                              )
                            ])
                          ]
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }